import { render, staticRenderFns } from "./app-woman.vue?vue&type=template&id=e0edaa22&scoped=true&"
import script from "./app-woman.vue?vue&type=script&lang=js&"
export * from "./app-woman.vue?vue&type=script&lang=js&"
import style0 from "./app-woman.vue?vue&type=style&index=0&id=e0edaa22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0edaa22",
  null
  
)

export default component.exports